<template>
  <div class="flex flex-row items-center">
    <a-tooltip v-for="(item, index) in visibleItems" :key="item.id || index">
      <template #title>{{ item.name || item.label || "User" }}</template>
      <div
        :style="{
          marginLeft: index > 0 ? `-${overlap}px` : '0',
          zIndex: index + 1,
        }"
        class="relative cursor-pointer"
      >
        <ProfileIcon
          :data="item"
          :size="size"
          :font="fontSize"
          :border-radius="borderRadius"
        />
      </div>
    </a-tooltip>

    <a-tooltip v-if="remainingCount > 0" placement="top">
      <template #title>
        <div class="flex flex-col gap-1 py-1">
          <div
            v-for="(item, index) in remainingItems"
            :key="item.id || index"
            class="flex items-center gap-2"
          >
            <ProfileIcon
              :data="item"
              :size="16"
              :font="8"
              :border-radius="borderRadius"
            />
            <span class="text-xs">{{ item.name || item.label || "User" }}</span>
          </div>
        </div>
      </template>
      <div
        class="border-none flex items-center justify-center cursor-pointer"
        :style="{
          ...countCircleStyle,
          marginLeft: visibleItems.length > 0 ? `-${overlap}px` : '0',
          zIndex: visibleItems.length + 1,
          backgroundColor: randomBackgroundColor,
          color: '#fff',
        }"
      >
        +{{ remainingCount }}
      </div>
    </a-tooltip>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { Tooltip as ATooltip } from "ant-design-vue";
import ProfileIcon from "@/src/components/ProfileIcon.vue";

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  maxVisible: {
    type: Number,
    default: 5,
  },
  size: {
    type: Number,
    default: 20,
  },
  fontSize: {
    type: Number,
    default: 9,
  },
  borderRadius: {
    type: Number,
    default: 50,
  },
  overlap: {
    type: Number,
    default: 8,
  },
});

const store = useStore();
const storeUsers = computed(() => store.getters["users/users"] || []);

const enrichItem = (item) => {
  if (!item?.id || item?.avatar_color) return item;
  const found = storeUsers.value.find((u) => u.id === item.id);
  return found || item;
};

const visibleItems = computed(() => {
  return props.items.slice(0, props.maxVisible).map(enrichItem);
});

const remainingItems = computed(() => {
  return props.items.slice(props.maxVisible).map(enrichItem);
});

const remainingCount = computed(() => {
  return Math.max(0, props.items.length - props.maxVisible);
});

const countCircleStyle = computed(() => {
  const sizeValue = `${props.size}px`;
  const fontValue = `${props.fontSize}px`;
  const radiusValue = `${props.borderRadius}px`;

  return {
    minWidth: sizeValue,
    minHeight: sizeValue,
    width: sizeValue,
    height: sizeValue,
    fontSize: fontValue,
    borderRadius: radiusValue,
  };
});

const randomBackgroundColor = computed(() => {
  const colors = [
    "#7095eb", // Blue
    "#a05bd5", // Purple
    "#55ba2d", // Green
    "#fa6000", // Orange
    "#0b84ff", // Light Blue
    "#c89826", // Yellow
    "#ac1c1e", // Red
  ];

  const index = props.items.length % colors.length;
  return colors[index];
});
</script>
